import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

import { PaginationControlsComponent } from 'ngx-pagination';
import { NgxPaginationModule } from 'ngx-pagination';
import { SharedModule } from '../shared/shared.module';
import { HttpClientModule } from '@angular/common/http';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';

import { CompaniesRfidBulkuploadComponent } from './companies-rfid-bulkupload/companies-rfid-bulkupload.component';
import { CompaniesRfidBulkuploadPreviewComponent } from './companies-rfid-bulkupload-preview/companies-rfid-bulkupload-preview.component';
import { DisburseMemberCardComponent } from './disburse-member-card/disburse-member-card.component';
import { DisburseMemberCardPreviewComponent } from './disburse-member-card-preview/disburse-member-card-preview.component';

const routes: Routes = [
  { path: '', component: CompaniesRfidBulkuploadComponent }, 
  { path: 'companies-rfid-bulkupload', component: CompaniesRfidBulkuploadComponent },
  { path: 'companies-rfid-bulkupload-preview', component: CompaniesRfidBulkuploadPreviewComponent },
  { path: 'disburse-member-card', component: DisburseMemberCardComponent },
  { path: 'disburse-member-card-preview', component: DisburseMemberCardPreviewComponent },
];


@NgModule({
  declarations: [
    CompaniesRfidBulkuploadComponent,
    CompaniesRfidBulkuploadPreviewComponent,
    DisburseMemberCardComponent,
    DisburseMemberCardPreviewComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgbModule,
    FormsModule,
    NgxPaginationModule,
    RouterModule.forChild(routes),
    SharedModule,
    ReactiveFormsModule,
    HttpClientModule,
    AngularSvgIconModule.forRoot(),
    AutocompleteLibModule,
    NgSelectModule,
  ],
  exports: [RouterModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AssignmembercardModule { }
